import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FilterPipe } from './filter.pipe';
import { SearchPipe } from './search.pipe';
import { ShortNamePipe } from './short-name.pipe';
import { TruncatePipe } from './truncate.pipe';
import { Nl2BrPipe } from './nl2br.pipe';
import { SafeHtmlPipe } from './safeHtml.pipe';

@NgModule({
  declarations: [FilterPipe, SearchPipe, ShortNamePipe, TruncatePipe, Nl2BrPipe, SafeHtmlPipe],
  imports: [CommonModule],
  exports: [FilterPipe, SearchPipe, ShortNamePipe, TruncatePipe, Nl2BrPipe, SafeHtmlPipe]
})

export class PipeModule { }
